"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _comments = require("composer-lib/redux/actions/comments");

var _conversations = require("composer-lib/redux/actions/conversations");

var _actions = require("composer-lib/redux/actions");

var _AppState = _interopRequireDefault(require("composer-lib/data/model/AppState"));

var _utils = require("composer-lib/lib/utils");

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _editor = require("composer-lib/redux/actions/editor");

var _helpers = require("composer-lib/lib/helpers");

var _editorConfigs = require("composer-lib/lib/editorConfigs");

var _editorChangeHelpers = require("composer-lib/lib/helpers/editorChangeHelpers");

var _composer = require("composer-lib/redux/actions/composer");

var _Composer = _interopRequireDefault(require("composer-lib/components/composer/Composer"));

var _ComposerSettings = _interopRequireDefault(require("composer-lib/data/model/ComposerSettings"));

var _lockHelpers = require("composer-lib/lib/helpers/lockHelpers");

var _reactRedux = require("react-redux");

var _draftJs = require("draft-js");

var _constants = require("composer-lib/lib/constants");

var _googleDocs = require("composer-lib/redux/actions/googleDocs");

var _pages = require("composer-lib/redux/actions/pages");

var _userAttributes = require("composer-lib/redux/actions/userAttributes");

var _highlightHelpers = require("composer-lib/lib/helpers/highlightHelpers");

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _Pages = _interopRequireDefault(require("composer-lib/data/model/Pages"));

var _RealtimeManager = _interopRequireDefault(require("composer-lib/data/RealtimeManager"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _lock = require("composer-lib/redux/actions/lock");

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _UISettings = _interopRequireDefault(require("composer-lib/data/model/UISettings"));

var HANDLED = _constants.DRAFT_CANCELLABLE_HANDLERS.HANDLED,
    NOT_HANDLED = _constants.DRAFT_CANCELLABLE_HANDLERS.NOT_HANDLED;

function postTitleIsNotPlaceholder(postData, compositionTypeString) {
  return postData.get('title') && postData.get('title') !== _I18n.default.text("composer-lib.composer.titlePlaceholder." + compositionTypeString);
}

function unsubscribeRealtime() {
  if (!(_RealtimeManager.default.client && _RealtimeManager.default.client.unsubscribeAll)) {
    return;
  }

  _RealtimeManager.default.client.unsubscribeAll();
}

var mapStateToProps = function mapStateToProps(state) {
  return {
    app: state.app,
    auth: state.auth,
    composition: state.composition,
    composerSettings: state.composerSettings,
    conversations: state.conversations,
    editorState: state.save.content,
    lock: state.lock,
    pages: state.pages,
    post: state.post,
    saveState: state.save,
    uiSettings: state.uiSettings
  };
};

var mapDispatchToProps = {
  addCommentFromUpdate: _comments.addCommentFromUpdate,
  addConversationFromUpdate: _conversations.addConversationFromUpdate,
  addToast: _actions.addToast,
  addUserToComposition: _actions.addUserToComposition,
  clipLinkLoaded: _editor.clipLinkLoaded,
  deleteCommentFromUpdate: _comments.deleteCommentFromUpdate,
  deleteConversationFromUpdate: _conversations.deleteConversationFromUpdate,
  insertableLoaded: _editor.insertableLoaded,
  insertImage: _editor.insertImage,
  insertVideo: _editor.insertVideo,
  insertEmbed: _editor.insertEmbed,
  fetchFullComposition: _composer.fetchFullComposition,
  fetchGoogleAccessToken: _googleDocs.fetchGoogleAccessToken,
  fetchGoogleAccounts: _googleDocs.fetchGoogleAccounts,
  fetchPages: _pages.fetchPages,
  fetchUserAttributes: _userAttributes.fetchUserAttributes,
  lockRequestFromUpdate: _lock.lockRequestFromUpdate,
  lockRequestRejectedFromUpdate: _lock.lockRequestRejectedFromUpdate,
  releaseLock: _lock.releaseLock,
  removeUserFromComposition: _actions.removeUserFromComposition,
  requestLock: _lock.requestLock,
  restoreSelection: _editor.restoreSelection,
  saveComposition: _composer.saveComposition,
  saveCompositionPending: _composer.saveCompositionPending,
  setInitialBodyContent: _composer.setInitialBodyContent,
  setInitialSummary: _composer.setInitialSummary,
  setInitialTitle: _composer.setInitialTitle,
  showLockedModal: _lock.showLockedModal,
  updateCompositionFromUpdate: _composer.updateCompositionFromUpdate,
  updateContentToSave: _composer.updateContentToSave,
  updateLockFromUpdate: _lock.updateLockFromUpdate,
  updateTitleToSave: _composer.updateTitleToSave
};
var ComposerContainer = (0, _createReactClass.default)({
  displayName: "ComposerContainer",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    addCommentFromUpdate: _propTypes.default.func.isRequired,
    addConversationFromUpdate: _propTypes.default.func.isRequired,
    addToast: _propTypes.default.func.isRequired,
    addUserToComposition: _propTypes.default.func.isRequired,
    app: _propTypes.default.instanceOf(_AppState.default).isRequired,
    auth: _propTypes.default.object.isRequired,
    backLink: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
    children: _propTypes.default.node.isRequired,
    clipLinkLoaded: _propTypes.default.func.isRequired,
    composerSettings: _propTypes.default.instanceOf(_ComposerSettings.default).isRequired,
    composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
    deleteCommentFromUpdate: _propTypes.default.func.isRequired,
    deleteConversationFromUpdate: _propTypes.default.func.isRequired,
    fetchFullComposition: _propTypes.default.func,
    fetchPages: _propTypes.default.func.isRequired,
    fetchUserAttributes: _propTypes.default.func,
    insertableLoaded: _propTypes.default.func.isRequired,
    insertImage: _propTypes.default.func.isRequired,
    insertVideo: _propTypes.default.func.isRequired,
    insertEmbed: _propTypes.default.func.isRequired,
    lock: _propTypes.default.instanceOf(_Lock.default).isRequired,
    lockRequestFromUpdate: _propTypes.default.func.isRequired,
    lockRequestRejectedFromUpdate: _propTypes.default.func.isRequired,
    pages: _propTypes.default.instanceOf(_Pages.default).isRequired,
    releaseLock: _propTypes.default.func.isRequired,
    removeUserFromComposition: _propTypes.default.func.isRequired,
    requestLock: _propTypes.default.func.isRequired,
    restoreSelection: _propTypes.default.func.isRequired,
    saveComposition: _propTypes.default.func,
    saveState: _propTypes.default.instanceOf(_SaveState.default).isRequired,
    setInitialBodyContent: _propTypes.default.func.isRequired,
    setInitialSummary: _propTypes.default.func.isRequired,
    setInitialTitle: _propTypes.default.func.isRequired,
    showLockedModal: _propTypes.default.func,
    uiSettings: _propTypes.default.instanceOf(_UISettings.default).isRequired,
    updateCompositionFromUpdate: _propTypes.default.func.isRequired,
    updateContentToSave: _propTypes.default.func.isRequired,
    updateLockFromUpdate: _propTypes.default.func.isRequired,
    updateTitleToSave: _propTypes.default.func.isRequired
  },
  childContextTypes: {
    gates: _propTypes.default.instanceOf(_immutable.Set)
  },
  getChildContext: function getChildContext() {
    return {
      gates: this.props.auth.gates
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    this.fetchInitialData();
    this.updateHelpers = (0, _helpers.makeComposerHelperUpdater)(this, [_helpers.ComposerHelperNames.SAVE_CHANGED_COMPOSITION]);
    this.updateHelpers();

    if (this.props.composerSettings.features[_constants.ComposerFeatures.PRESENCE]) {
      this.startRealtime();
      window.addEventListener('beforeunload', unsubscribeRealtime);
    }
  },
  componentDidMount: function componentDidMount() {
    window.addEventListener('beforeunload', this.checkForUnsavedChanges);
    window.addEventListener('beforeunload', this.releaseLockIfHeld);
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var prevComposition = this.props.composition;
    var composition = nextProps.composition;

    if (prevComposition.get('type') !== composition.get('type')) {
      nextProps.fetchPages(composition.get('type'));
    }

    this.updateHelpers(nextProps);
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    var _this$props = this.props,
        auth = _this$props.auth,
        composition = _this$props.composition,
        lock = _this$props.lock,
        saveState = _this$props.saveState;
    var locked = (0, _lockHelpers.compositionLocked)(lock, auth, saveState);

    if (prevProps.composition.status !== _constants.RequestStatus.SUCCEEDED && composition.status === _constants.RequestStatus.SUCCEEDED) {
      // we need to load the body and title state into redux before we can display the composer
      this.createInitialComposerState();
    } else if (locked && composition.status === _constants.RequestStatus.SUCCEEDED && !(0, _immutable.is)(prevProps.composition, composition)) {
      this.updateLockedComposerState();
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    window.removeEventListener('beforeunload', this.checkForUnsavedChanges);
    window.removeEventListener('beforeunload', this.releaseLockIfHeld);
    window.removeEventListener('beforeunload', unsubscribeRealtime);
    this.saveChangedComposition();
    this.releaseLockIfHeld();
    unsubscribeRealtime();
  },
  startRealtime: function startRealtime() {
    var userId = this.props.auth.user.get('user_id');

    _RealtimeManager.default.init({
      addCommentFromUpdate: this.props.addCommentFromUpdate,
      addConversationFromUpdate: this.props.addConversationFromUpdate,
      addUserToComposition: this.props.addUserToComposition,
      compositionId: this.props.composerSettings.compositionId,
      deleteCommentFromUpdate: this.props.deleteCommentFromUpdate,
      deleteConversationFromUpdate: this.props.deleteConversationFromUpdate,
      lockRequestFromUpdate: this.props.lockRequestFromUpdate,
      lockRequestRejectedFromUpdate: this.props.lockRequestRejectedFromUpdate,
      removeUserFromComposition: this.props.removeUserFromComposition,
      updateCompositionFromUpdate: this.props.updateCompositionFromUpdate,
      updateLockFromUpdate: this.props.updateLockFromUpdate,
      userId: userId,
      withPresence: true
    });
  },
  fetchInitialData: function fetchInitialData() {
    var _this$props2 = this.props,
        auth = _this$props2.auth,
        composition = _this$props2.composition,
        composerSettings = _this$props2.composerSettings;
    var compositionId = composerSettings.compositionId;
    var session = auth.session,
        user = auth.user;
    var userId = user.get('user_id');
    this.props.fetchFullComposition(compositionId, session);
    this.props.requestLock(compositionId, session);
    this.props.fetchPages(composition.get('type'));
    this.props.fetchUserAttributes(userId);
  },
  createInitialComposerState: function createInitialComposerState() {
    this.createInitialBodyState();
    this.createInitialTitleState();

    if (this.props.composition.get('type') === _constants.CompositionTypes.KNOWLEDGE_ARTICLE) {
      this.createInitialSummaryState();
    }
  },
  updateLockedComposerState: function updateLockedComposerState() {
    this.updatedLockedTitleState();
    this.updatedLockedBodyState();

    if (this.props.composition.get('type') === _constants.CompositionTypes.KNOWLEDGE_ARTICLE) {
      this.updatedLockedSummaryState();
    }
  },
  checkForUnsavedChanges: function checkForUnsavedChanges(e) {
    var composition = this.props.composition;
    var _this$props$saveState = this.props.saveState,
        contentChanged = _this$props$saveState.contentChanged,
        titleChanged = _this$props$saveState.titleChanged;

    if (!composition.getIn(['data', 'readOnly']) && (contentChanged || titleChanged)) {
      this.saveChangedComposition();

      var msg = _I18n.default.text('composer-lib.global.unsavedChangesWarning');

      e.returnValue = msg;
      return msg;
    } // have to explicitly return undefined to make IE10 happy


    return undefined;
  },
  releaseLockIfHeld: function releaseLockIfHeld() {
    var _this$props3 = this.props,
        auth = _this$props3.auth,
        composerSettings = _this$props3.composerSettings,
        lock = _this$props3.lock,
        saveState = _this$props3.saveState;
    var locked = (0, _lockHelpers.compositionLocked)(lock, auth, saveState);

    if (!locked) {
      this.props.releaseLock(composerSettings.compositionId, auth.session);
    } // have to explicitly return undefined to make IE10 happy


    return undefined;
  },
  updatedLockedTitleState: function updatedLockedTitleState() {
    var _this$props4 = this.props,
        composition = _this$props4.composition,
        saveState = _this$props4.saveState;
    var data = composition.data;
    var title = saveState.title;
    var newTitle = data.get('title');

    if (title === newTitle) {
      return;
    }

    this.props.setInitialTitle(newTitle);
  },
  updatedLockedSummaryState: function updatedLockedSummaryState() {
    var _this$props5 = this.props,
        composition = _this$props5.composition,
        saveState = _this$props5.saveState;
    var data = composition.data;
    var summary = saveState.summary;
    var newSummary = data.get('summary');

    if (summary === newSummary) {
      return;
    }

    this.props.setInitialSummary(newSummary);
  },
  updatedLockedBodyState: function updatedLockedBodyState() {
    var data = this.props.composition.data;
    var parsedBody = data.get('parsedBody');
    var justUpdated = data.get('justUpdated');

    if (!justUpdated) {
      return;
    }

    var editorState = _draftJs.EditorState.createEmpty();

    var bodyData = null;

    if (parsedBody) {
      bodyData = (0, _draftJs.convertFromRaw)(parsedBody);
    }

    if (bodyData) {
      editorState = _draftJs.EditorState.createWithContent(bodyData);
      editorState = (0, _highlightHelpers.highlightChanges)(data, editorState);
    }

    this.props.setInitialBodyContent(editorState);
  },
  createInitialTitleState: function createInitialTitleState() {
    var composition = this.props.composition;
    var data = composition.data,
        typeString = composition.typeString;
    var title = '';

    if (postTitleIsNotPlaceholder(data, typeString)) {
      title = data.get('title');
    }

    this.props.setInitialTitle(title);
  },
  createInitialBodyState: function createInitialBodyState() {
    var _this = this;

    var _this$props6 = this.props,
        composerSettings = _this$props6.composerSettings,
        composition = _this$props6.composition;
    var data = composition.data;

    var editorState = _draftJs.EditorState.createEmpty();

    if (data.get('body') && data.get('body') !== '{}') {
      var content = (0, _draftJs.convertFromRaw)(JSON.parse(data.get('body')));
      editorState = _draftJs.EditorState.createWithContent(content);
    } else if (data.get('htmlBody')) {
      var editorOptions = {
        props: {
          addToast: this.props.addToast
        }
      };

      var _content = (0, _editorConfigs.convertFromHTML)(composerSettings, editorOptions)(data.get('htmlBody'));

      setTimeout(function () {
        _this.props.updateContentToSave(_draftJs.EditorState.createWithContent(_content));

        _this.saveChangedComposition();
      }, 0);
    }

    this.props.setInitialBodyContent(editorState);
  },
  createInitialSummaryState: function createInitialSummaryState() {
    var data = this.props.composition.data;
    var summary = data.get('summary') || '';
    this.props.setInitialSummary(summary);
  },
  bodyContentKeyCommandListener: function bodyContentKeyCommandListener(editorState, command) {
    if (command === _constants.KeyCommands.DELETE_IMAGE) {
      this.props.updateContentToSave((0, _editorChangeHelpers.deleteImageFromEditorState)(editorState));
      return HANDLED;
    }

    return NOT_HANDLED;
  },
  render: function render() {
    var _this$props7 = this.props,
        app = _this$props7.app,
        auth = _this$props7.auth,
        backLink = _this$props7.backLink,
        composition = _this$props7.composition,
        lock = _this$props7.lock,
        pages = _this$props7.pages,
        saveState = _this$props7.saveState,
        uiSettings = _this$props7.uiSettings;
    var backLinkProp = (0, _utils.callIfPossible)(backLink, composition);
    return _react.default.createElement(_Composer.default, {
      addToast: this.props.addToast,
      app: app,
      auth: auth,
      backLink: backLinkProp,
      clipLinkLoaded: this.props.clipLinkLoaded,
      composition: composition,
      editorState: saveState.content,
      insertableLoaded: this.props.insertableLoaded,
      insertImage: this.props.insertImage,
      insertVideo: this.props.insertVideo,
      insertEmbed: this.props.insertEmbed,
      keyCommandListeners: [this.bodyContentKeyCommandListener],
      lock: lock,
      onChange: this.props.updateContentToSave,
      pages: pages,
      releaseLock: this.props.releaseLock,
      restoreSelection: this.props.restoreSelection,
      saveChangedComposition: this.saveChangedComposition,
      saveComposition: this.props.saveComposition,
      saveState: saveState,
      setInitialBodyContent: this.props.setInitialBodyContent,
      setInitialTitle: this.props.setInitialTitle,
      showLockedModal: this.props.showLockedModal,
      uiSettings: uiSettings,
      updateContentToSave: this.props.updateContentToSave,
      updateTitleToSave: this.props.updateTitleToSave
    }, this.props.children);
  }
});

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ComposerContainer);

exports.default = _default;
module.exports = exports.default;